import _ from 'lodash';

import urls from '../urls';
import config from '../config';
import {
    ActionTypes,
    TimeDirections,
    JourneyPlannerLayout,
    DelayRepayPaymentMethod,
    GenericModals,
    CookieKeys
} from '../constants/AppConstants';
import BaseStore from './BaseStore';
import { translate as t } from '../lib/I18n';
import { hotJarTrigger } from '../helpers/HotJar';
import EcommerceHelper from '../helpers/DataLayerEcommerce';
import CookieHelper from '../helpers/Cookie';
import UserStore from '../stores/UserStore';


export function location () {
    const { pathname, search } = window.location;
    return pathname + search;
}

export const cleanEventName = (event) => {
    return event.toLowerCase().replace(/ |_/g, '-');
};

class DataLayerStore extends BaseStore {

    getActionHandlers () {
        return {
            [ ActionTypes.TRACKING_ENABLED]: this.trackingEnabled,
            [ ActionTypes.TRACKING_DISABLED]: this.trackingDisabled,
            [ ActionTypes.ROUTE_CHANGED ]: this.pageView,
            [ ActionTypes.MODAL_OPENED ]: this.modalOpened,
            [ ActionTypes.GENERIC_MODAL_OPEN ]: this.genericModalOpened,

            [ ActionTypes.LOGGED_IN ]: this.loggedIn,
            [ ActionTypes.LOGGED_OUT ]: this.simpleEvent,
            [ ActionTypes.REGISTRATION_SUCCESS ]: this.simpleEvent,
            [ ActionTypes.SMARTCARD_REGISTERED ]: this.simpleEvent,
            [ ActionTypes.SMARTCARD_LINKED ]: this.simpleEvent,
            [ ActionTypes.KEYGO_REGISTRATION_COMPLETE ]: this.simpleEvent,

            [ ActionTypes.STATION_FINDER_SET_EXPANDED ]: this.simpleEvent,

            [ ActionTypes.SEARCH_FINISHED ]: this.pointSearch,
            [ ActionTypes.SEASON_SEARCH_FINISHED ]: this.seasonSearch,

            [ ActionTypes.SHOW_EARLIER_TRAINS_STARTED ]: this.earlierLater(TimeDirections.EARLIER),
            [ ActionTypes.SHOW_LATER_TRAINS_STARTED ]: this.earlierLater(TimeDirections.LATER),

            [ ActionTypes.DELIVERY_METHOD ]: this.deliveryMethod,
            [ ActionTypes.PAYMENT_METHOD ]: this.paymentMethod,

            [ ActionTypes.ORDER_PAID ]: this.orderPaid,
            [ ActionTypes.ORDER_CREATED ]: this.orderCreated,
            [ ActionTypes.ORDER_TRIP_CREATED ]: this.addToBasket,
            [ ActionTypes.ORDER_TRIP_DELETED ]: this.removeFromBasket,
            [ ActionTypes.BASKET_CLEARED ]: this.event.bind(this, 'order:cleared', null),

            [ ActionTypes.WIDGET_SEARCH_STATION_SELECT ]: this.widgetStationSelector,
            [ ActionTypes.WIDGET_SEARCH_STATION_SWITCH ]: this.widgetStationSwitch,
            [ ActionTypes.WIDGET_SEARCH_CLICK ]: this.widgetSearchClick,
            [ ActionTypes.WIDGET_SEARCH_DAY_SELECT ]: this.widgetDaySelect,

            [ ActionTypes.FARES_EXPAND ]: this.faresExpand,
            [ ActionTypes.PLUS_BUS_SELECT ]: this.plusBusSelect,

            [ ActionTypes.EXTERNAL_LINK ]: this.externalLink,

            [ ActionTypes.JP_CHANGE_LAYOUT ]: this.jpChangeLayout,
            [ ActionTypes.JP_FARE_CLASS_FILTER_CLICK ]: this.jpChangeFareClassFilter,
            [ ActionTypes.JP_FARE_SELECTION_FILTER_CLICK ]: this.jpChangeFareSelectionFilter,
            [ ActionTypes.JP_TOC_SPECIFIC_FILTER_RENDERED ]: this.jpTocSpecificFilterRender,
            [ ActionTypes.JP_TOC_SPECIFIC_FILTER_CLICK ]: this.jpTocSpecificFilterClick,
            [ ActionTypes.JP_ALL_FARES_ACCORDION_CLICK ]: this.jpAllFaresAccordionClick,
            [ ActionTypes.JP_CHECKOUT_WITH_SUGGESTED_PRODUCTS ]: this.jpCheckoutWithSuggestedProducts,
            [ ActionTypes.JP_CHANGE_SEARCH_TYPE ]: this.jpChangedSearchType,

            [ ActionTypes.TUTORIAL_TOGGLE ]: this.handleTutorialToggle,

            [ ActionTypes.STATION_FINDER_SEARCH_STARTED ]: this.stationFinderSearch,
            [ ActionTypes.STATION_FINDER_STATION_SELECTED ]: this.stationFinderSelected,

            [ ActionTypes.FAVOURITES_ADDED ]: this.addFavourite,
            [ ActionTypes.FAVOURITES_REMOVED ]: this.removeFavourite,
            [ ActionTypes.FAVOURITE_ADDED_TO_BASKET ]: this.addFavouriteToBasket,
            [ ActionTypes.REORDER_ADDED_TO_BASKET ]: this.addReorderToBasket,

            [ ActionTypes.DISRUPTION_ALERT_CREATED ]: this.addDisruptionAlert,
            [ ActionTypes.DISRUPTION_ALERT_DELETED ]: this.deleteDisruptionAlert,

            [ ActionTypes.AUTO_DR_CLAIM_DISMISSED ]: this.event.bind(this, 'page:event:auto_dr_claim_dismissed', null),
            [ ActionTypes.AUTO_DR_CLAIM_SELECTED ]: this.event.bind(this, 'page:event:auto_dr_claim_selected', null),
            [ ActionTypes.AUTO_DR_CLAIM_SUBMITTED ]: this.submitAutoDRClaim,

            [ ActionTypes.RETURN_TRAVELCARD_CTA_CLICK ]: this.returnTravelcardAdded,

            [ ActionTypes.REFUND_COMPLETE ]: this.refundComplete,

            [ ActionTypes.AMEND_CTA_CLICKED ]: this.event.bind(this, 'page:event:amend-cta-clicked', null),
            [ ActionTypes.AMEND_CONFIRMED ]: this.confirmAmendBooking,

            [ ActionTypes.WIDGETS_RENDER_JP ]: this.widgetsRender,
            [ ActionTypes.WIDGETS_VIEW_RESULTS ]: this.widgetsViewResults,

            [ ActionTypes.RAILCARD_JOBCENTREPLUS_CHECKED ]: this.toggleJobcenterPlusRailcard,

            [ ActionTypes.SHOW_FLEXI_WARNING_MODAL ]: this.showFlexiWarningModal,
            [ ActionTypes.FLEXI_WARNING_MODAL_ACKNOWLEDGEMENT_CHECKBOX_CHECKED ]: this.flexiWarningModalAcknowledgementCheckboxChecked,
            [ ActionTypes.FLEXI_WARNING_MODAL_ACKNOWLEDGEMENT_CHECKBOX_UNCHECKED ]: this.flexiWarningModalAcknowledgementCheckboxUnchecked,
            [ ActionTypes.FLEXI_WARNING_MODAL_CLOSE ]: this.flexiWarningModalClose,
            [ ActionTypes.FLEXI_WARNING_MODAL_CONTINUE ]: this.flexiWarningModalContinue,
            [ ActionTypes.FLEXI_WARNING_MODAL_MORE_INFO_CLICKED ]: this.flexiWarningModalMoreInfoClicked,

            [ ActionTypes.USER_OPTED_IN ]: this.userOptedIn,
            [ ActionTypes.USER_OPTED_OUT ]: this.userOptedOut,
            [ ActionTypes.SELECT_NOTIFICATION_PREFERENCE ]: this.selectNotificationPreference,
            [ ActionTypes.SELECT_REPAYMENT_METHOD ]: this.selectRepaymentMethod,
            [ ActionTypes.AMEND_NOTIFICATION_PREFERENCE ]: this.amendNotificationPreference,
            [ ActionTypes.AMEND_REPAYMENT_METHOD ]: this.amendRepaymentMethod,
            [ ActionTypes.AMEND_ADDRESS ]: this.amendAddress,

            [ ActionTypes.SAVE_REGULAR_JOURNEY_WITH_OCDR_FAV_JOURNEY ]: this.saveRegularJourneyWithOCDRFavJourney,
            [ ActionTypes.WEBCHAT_OPENED ]: this.webchatOpened,

            [ ActionTypes.BACK_FROM_PAYMENT_PAGE ]: this.pageEvent,
            [ ActionTypes.ADD_ANOTHER_JOURNEY_ON_DELIVERY_PAGE ]: this.pageEvent,
            [ ActionTypes.ADD_ANOTHER_JOURNEY_ON_PAYMENT_PAGE ]: this.pageEvent,
            [ ActionTypes.ADD_ANOTHER_JOURNEY_ON_BASKET_MODAL ]: this.modalEvent,
            [ ActionTypes.DELIVERY_SCREEN_BACK_NAVIGATION_TICKET_REMOVED ]: this.modalEvent,
            [ ActionTypes.DELIVERY_SCREEN_BACK_NAVIGATION_TICKET_KEPT ]: this.modalEvent,

            [ ActionTypes.CREATE_ACCESSIBILITY_PROFILE_LOADED ]: this.createAccessibilityProfile,
            [ ActionTypes.UPDATE_ACCESSIBILITY_PROFILE_LOADED ]: this.updateAccessibilityProfile,
            [ ActionTypes.BOOK_ASSIST_SUCCESS ]: this.bookPassengerAssist,
            [ ActionTypes.BOOK_MANY_ASSISTS_SUCCESS ]: this.bookPassengerAssistWithOrder,
            [ ActionTypes.CANCEL_ASSISTED_BOOKING_SUCCESS ]: this.cancelPassengerAssist,
            [ ActionTypes.EDIT_ASSISTED_BOOKING_SUCCESS ]: this.editPassengerAssist,
            [ ActionTypes.FETCH_CHILD_SMARTCARD_REPLACEMENT_STARTED ]: this.trackChildSmartcardReplacementPageView,
            [ ActionTypes.REQUEST_CHILD_SMARTCARD_REPLACEMENT_STARTED ]: this.trackChildSmartcardReplacementRequest,
        };
    }

    simpleEvent ({ actionType }) {
        this.event(actionType.toLowerCase());

        if (actionType === ActionTypes.LOGGED_OUT) {
            this.removeTripWithPassengerAssist();
        }
    }

    pageEvent ({ context }) {
        this.event(`page:event:${context}`);
    }

    modalEvent ({ context }) {
        this.event(`modal:event:${context}`);
    }

    event (name, data) {
        if (this.name === 'order:cleared') {
            this.removeTripWithPassengerAssist();
        }

        const dataLayerName = config.get('gtmDataLayer');
        const enableTracking = this.isTrackingEnabled();

        const user = UserStore.getCurrent();

        const userID = user && user.customer && user.customer.id;

        if (window.hasOwnProperty(dataLayerName) && enableTracking) {
            const payload = Object.assign({
                event: `OTRL:${name}`,
                userID,
            }, data);

            window[dataLayerName].push(payload);
        }
    }

    pointSearch ({ search }) {
        const serialized = search.serialize();

        const data = Object.assign(
            serialized.params,
            serialized.query,
            {
                originName: search.origin.name,
                destinationName: search.destination.name,
                journeyType: search.ticketType.toLowerCase(),
                smartcard: search.smartcard
            }
        );
        this.event('search:point', data);
    }

    seasonSearch ({ search }) {
        const serialized = search.serialize();

        const data = Object.assign(
            serialized.params,
            serialized.query,
            {
                originName: search.origin.name,
                destinationName: search.destination.name,
                smartcard: search.smartcard
            }
        );
        this.event('search:season', data);
    }

    loggedIn ({ user }) {
        this.event('login', {
            userID: user.id
        });
    }

    pageView ({ location: routeLocation }) {
        const route = urls.resolve(routeLocation.pathname);
        const title = t(`pageTitles.${route.name}`, null, t('pageTitles.default'));
        this.event(`page:${route.name}`, {
            'pageURL': location(),
            'pageTitle': title
        });
    }

    widgetStationSelector ({ search }) {
        this.event(`widget-search:event:select-${search.type}`, {
            'pageURL': location(),
            'station': search.stationName
        });
    }

    widgetStationSwitch () {
        this.event(`widget-search:event:station-switch`, {
            'pageURL': location(),
        });
    }

    widgetSearchClick ({type}) {
        this.event(`widget-search:event:click-${type.name}`, {
            ...(type.value && { 'value': type.value }),
            'pageURL': location(),
        });
    }

    widgetDaySelect ({ data }) {
        this.event(`widget-search:event:calendar-day-select${data.type ? '-' + data.type : ''}`, {
            'value': data.date.toDate(),
            'pageURL': location(),
        });
    }

    faresExpand ({type}) {
        this.event(`fares-click:${cleanEventName(type.name)}`, {
            'pageURL': location(),
        });
    }

    plusBusSelect ({type}) {
        this.event(`plus-bus:${type.action}:${type.name}`, {
            'pageURL': location(),
        });
    }

    externalLink ({type}) {
        this.event(`click-external-link:${type.name}`, {
            'pageURL': location(),
        });
    }

    modalOpened({ type }) {
        function functionName(fun) {
            let out = fun.toString();
            out = out.substr('function '.length);
            out = out.substr(0, out.indexOf('('));
            return out;
        }
        if (_.isFunction(type)) {
            type = functionName(type);
        }
        this.event(`modal:${type.toLowerCase()}`, { 'pageURL': location() });
    }

    genericModalOpened ({ type }) {
        const cleanModalName = cleanEventName(type);
        if (type === GenericModals.JOURNEY_DETAILS_FORM) {
            hotJarTrigger(type);
        }
        this.event(`modal:${cleanModalName}`);
    }

    orderPaid ({ order }) {
        let data = EcommerceHelper.purchase(order);
        data.extra = {
            'deliveryOption': order.delivery.displayName,
        };

        this.event('order:paid', data);
    }

    orderCreated ({ order, trip }) {
        this.event('order:started', EcommerceHelper.orderStarted(order.id));
        this.addToBasket({ orderTrip: order.trips.first(), trip });
        this.addTripWithPassengerAssist();
    }

    deliveryMethod ({ order, eventType = 'main' }) {
        if (eventType === 'main') {
            this.event('order:deliveryMethods', EcommerceHelper.deliveryPage(order.id));
        } else {
            this.event('order:deliveryMethodSelected', EcommerceHelper.deliveryMethod(order.id, order.delivery.internalName));
        }
    }

    paymentMethod ({ id, paymentMethod, eventType = 'main' }) {
        if (eventType === 'main') {
            this.event('order:paymentMethods', EcommerceHelper.paymentPage(id));
        } else {
            this.event('order:paymentMethodSelected', EcommerceHelper.paymentMethod(id, paymentMethod));
        }
    }

    addToBasket ({ orderTrip, trip }) {
        let data = EcommerceHelper.addToBasket(orderTrip);
        if (trip.search.targetLayout) {
            data.extra = {
                jpLayout: trip.search.targetLayout.toLowerCase()
            };

            if (trip.search.targetLayout === JourneyPlannerLayout.GRID || trip.search.targetLayout === JourneyPlannerLayout.GRID_2) {
                data.extra.preselectedBasket = trip.raw ? 'yes' : 'no';
            }
        }
        this.event('order:addToBasket', data);
        this.addTripWithPassengerAssist();
    }

    removeFromBasket ({ orderTrip }) {
        this.event('order:removeFromBasket', EcommerceHelper.removeFromBasket(orderTrip));
        this.removeTripWithPassengerAssist();
    }

    returnTravelcardAdded ({ orderTrip }) {
        if (orderTrip) {
            this.event('order:returnTravelcardUpgrade', EcommerceHelper.addToBasket(orderTrip));
        }
    }

    earlierLater (timeDirection) {
        return ({ tripDirection }) => {
            this.event(`page:event:${tripDirection.toLowerCase()}-${timeDirection.toLowerCase()}-click`);
        };
    }

    jpChangedSearchType ({ searchType }) {
        this.event(`page:event:changed-search-type-to-${searchType}`);
    }

    jpCheckoutWithSuggestedProducts () {
        this.event(`page:event:first-action-add-to-basket`);
    }

    jpAllFaresAccordionClick ({ value }) {
        this.event(`page:event:view-all-fares-${(value ? 'open' : 'close')}`);
    }

    jpTocSpecificFilterClick ({ value }) {
        this.event(`page:event:toc-specific-checkbox-${(value ? 'on' : 'off')}`);
    }

    jpTocSpecificFilterRender () {
        this.event(`page:event:render:toc-specific-filter-rendered`);
    }

    jpChangeFareClassFilter ({ fareClass, value }) {
        this.event(`page:event:${fareClass}-checkbox-${(value ? 'on' : 'off')}`);
    }

    jpChangeFareSelectionFilter ({ selection }) {
        this.event(`page:event:filter-${selection.toLowerCase()}-selected`);
    }

    jpChangeLayout ({layout}) {
        this.event(`page:event:${layout.toLowerCase()}-tab-click`);
    }

    handleTutorialToggle ({ tutorialName, open, dismissed, lastStage, currentStage }) {
        const close = `-close-${currentStage}-of-${lastStage}`;
        this.event(`modal:tutorial-${tutorialName}${(open ? '' : close)}`);
        if (dismissed) {
            this.event(`modal:tutorial-${tutorialName}-dismissed`);
        }
    }

    stationFinderSearch ({ searchInteraction, latitude, longitude }) {
        this.event(`page:event:find-station:${searchInteraction}:${latitude},${longitude}`);
    }

    stationFinderSelected ({ originDest, station }) {
        this.event(`page:event:found-station-used:${originDest}:${station.nlc}-${station.name}`);
    }

    refundComplete ({ isFlexiRefund }) {
        this.event(`page:event:refund-completed${(isFlexiRefund ? ':is-flexi' : '')}`);
    }

    addFavourite ({ context }) {
        this.event(`page:event:favourite-add${(context ? ':' + context : '')}`);
    }

    toggleJobcenterPlusRailcard ({ type }) {
        this.event(type);
    }

    removeFavourite ({ context }) {
        this.event(`page:event:favourite-remove${(context ? ':' + context : '')}`);
    }

    addFavouriteToBasket ({ success }) {
        this.event(`page:event:favourite-added-to-basket:${success ? 'successful' : 'failed'}`);
    }

    addReorderToBasket ({ success }) {
        this.event(`page:event:reorder-added-to-basket:${success}`);
    }

    addDisruptionAlert ({ context }) {
        this.event(`page:event:disruption-alert-add${(context ? ':' + context : '')}`);
    }

    deleteDisruptionAlert ({ context }) {
        this.event(`page:event:disruption-alert-delete${(context ? ':' + context : '')}`);
    }

    submitAutoDRClaim ({ paymentId, editDelayLength }) {
        const paymentMethodString = _.get(_.invert(DelayRepayPaymentMethod), paymentId).toLowerCase();
        const amendDelayLenth = Boolean(editDelayLength);
        this.event(`page:event:auto_dr_claim_submitted:amend-length-${amendDelayLenth}:payment-method-${paymentMethodString}`);
    }

    confirmAmendBooking ({ description }) {
        this.event(`page:event:amend-booking-confirmed:${description}`, null);
    }

    widgetsRender ({ brand, tabs, version }) {
        this.event('widgets:loaded', { brand, tabs, version });
    }

    widgetsViewResults ({ brand, tab, resultsUrl, version }) {
        this.event(`widgets:search-results:${tab}`, { brand, resultsUrl, version });
    }

    trackingEnabled () {
        const cookie = CookieHelper.get(CookieKeys.DO_NOT_TRACK);

        if (cookie) {
            CookieHelper.clear(CookieKeys.DO_NOT_TRACK);
            window.location.reload();
        }
    }

    trackingDisabled () {
        const cookie = CookieHelper.get(CookieKeys.DO_NOT_TRACK);

        if (!cookie) {
            CookieHelper.set(CookieKeys.DO_NOT_TRACK, true);
            window.location.reload();
        }
    }

    isTrackingEnabled () {
        return !CookieHelper.get(CookieKeys.DO_NOT_TRACK);
    }

    showFlexiWarningModal ({ context }) {
        this.event(`modal:openFlexiKeyGoWarning${(context ? ':' + context : '')}`);
    }

    flexiWarningModalAcknowledgementCheckboxChecked ({ context }) {
        this.event(`modal:flexiKeyGoWarningAcknowledgementCheckboxChecked${(context ? ':' + context : '')}`);
    }

    flexiWarningModalAcknowledgementCheckboxUnchecked ({ context }) {
        this.event(`modal:flexiKeyGoWarningAcknowledgementCheckboxUnchecked${(context ? ':' + context : '')}`);
    }

    flexiWarningModalClose ({ context }) {
        this.event(`modal:flexiKeyGoWarningClose${(context ? ':' + context : '')}`);
    }

    flexiWarningModalContinue ({ context }) {
        this.event(`modal:flexiKeyGoWarningContinue${(context ? ':' + context : '')}`);
    }

    flexiWarningModalMoreInfoClicked ({ context }) {
        this.event(`modal:flexiKeyGoWarningMoreInfoClicked${(context ? ':' + context : '')}`);
    }

    userOptedIn ({from}) {
        this.event(`page:event:OCDR-opt-in-${from}`);
    }

    userOptedOut () {
        this.event('page:event:OCDR-optout');
    }

    webchatOpened () {
        this.event('WCWidget:modal:open');
    }

    selectNotificationPreference ({method}) {
        this.event(`page:event:OCDR-notification-${method ? method : 'none'}`);
    }

    selectRepaymentMethod ({method}) {
        this.event(`page:event:OCDR-repayment-${method}`);
    }

    amendNotificationPreference () {
        this.event('page:event:OCDR-notification-amended');
    }

    amendRepaymentMethod () {
        this.event('page:event:OCDR-repayment-amended');
    }

    amendAddress () {
        this.event('page:event:OCDR-address-ammended');
    }

    saveRegularJourneyWithOCDRFavJourney () {
        this.event('page:event:OCDR-journey-with-notification');
    }

    createAccessibilityProfile ({ accessibilityProfile }) {
        this.event('passenger-assist:accessibility-profile-created', { accessibilityProfile });
    }

    updateAccessibilityProfile ({ accessibilityProfile }) {
        this.event('passenger-assist:accessibility-profile-updated', { accessibilityProfile });
    }

    bookPassengerAssist ({ bookedAssist, context }) {
        // Don't fire the event if we're on the payment confirmation page as there is a separate event to track PA bookings from there
        if (context !== 'paymentConfirmation') {
            this.event('passenger-assist:requested', { bookedAssist });
        }
    }

    bookPassengerAssistWithOrder ({ bookedAssist }) {
        this.event('passenger-assist:added-to-the-order', { bookedAssist });
    }

    cancelPassengerAssist ({ sysId }) {
        this.event('passenger-assist:canceled', { sysId });
    }

    editPassengerAssist ({ passengerAssist }) {
        this.event('passenger-assist:amended', { passengerAssist });
    }

    addTripWithPassengerAssist () {
        this.event('passenger-assist:added-to-the-order');
    }

    removeTripWithPassengerAssist () {
        this.event('passenger-assist:removed-from-the-order');
    }

    requestPassengerAssistWithOrder () {
        this.event('passenger-assist:requested-with-order');
    }

    trackChildSmartcardReplacementPageView ({ userId }) {
        this.event('child-smartcard-replacement:page-view', { userId });
    }

    trackChildSmartcardReplacementRequest ({ userId }) {
        this.event('child-smartcard-replacement:request:confirm', { userId });
    }
}

const storeInstance = new DataLayerStore();

export default storeInstance;



// WEBPACK FOOTER //
// ./src/stores/DataLayerStore.js